<template>
    <div class="container ">
        <div class="row">
            <div class="col-6 mb-5">
                <img alt="Responsive image" class="img-fluid" src="/images/torta.png">
            </div>
            <div class="col-6">
                <img alt="Responsive image" class="img-fluid" src="/images/piramide.jpeg">
            </div>
            <div class="col-6">
                <img alt="Responsive image" class="img-fluid" src="/images/barras.png">
            </div>
            <div class="col-6">
                <img alt="Responsive image" class="img-fluid" src="/images/barras.png">
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    components: {},
    data: () => {
      return {}
    },
    mounted () {

    },
    computed: {},
    created () {

    },
    methods: {}
  }
</script>

<style lang="stylus">
</style>


